import { Detergent, ImportCsvRequest, ImportCsvResponse } from '@/types'
import { DeleteCustomerRequest } from '@/types/apis/customers/DeleteCustomerRequest'
import { DeleteCustomerResponse } from '@/types/apis/customers/DeleteCustomerResponse'
import { CreateDetergentResponse } from '@/types/apis/detergents/CreateDetegentResponse'
import { CreateDetergentRequest } from '@/types/apis/detergents/CreateDetergentRequest'
import { GetAllDetergentsResponse } from '@/types/apis/detergents/GetAllDetergentsResponse'
import { GetDetergentRequest } from '@/types/apis/detergents/GetDetergentRequest'
import { GetDetergentResponse } from '@/types/apis/detergents/GetDetergentResponse'
import { UpdateDetergentRequest } from '@/types/apis/detergents/UpdateDetergentRequest'
import { UpdateDetergentResponse } from '@/types/apis/detergents/UpdateDetergentResponse'

import axios from './axios'

const API_ENDPOINT = '/detergent'

export const getAllDetergents = ({
  limit,
  page,
}: {
  limit?: number
  page?: number
}): Promise<GetAllDetergentsResponse> => {
  return axios.get(`${API_ENDPOINT}?limit=${limit}&page=${page}`)
}

export const getDetergents = (): Promise<Detergent[]> => {
  return axios.get(`${API_ENDPOINT}/all`)
}

export const getDetergent = (request?: GetDetergentRequest): Promise<GetDetergentResponse> => {
  return axios.get(`${API_ENDPOINT}/${request?.id}`)
}

export const createDetergent = (request: CreateDetergentRequest): Promise<CreateDetergentResponse> => {
  return axios.post(API_ENDPOINT, request)
}

export const updateDetergent = (request: UpdateDetergentRequest): Promise<UpdateDetergentResponse> => {
  return axios.put(`${API_ENDPOINT}/${request.id}`, request)
}

export const deleteDetergent = (request: DeleteCustomerRequest): Promise<DeleteCustomerResponse> => {
  return axios.delete(`${API_ENDPOINT}/${request.id}`)
}

export const importDetergent = (request: ImportCsvRequest): Promise<ImportCsvResponse> => {
  return axios.post(`${API_ENDPOINT}/import-csv`, request)
}
